import { BaseRepository } from "@/repositories/base-repository"
import type { IProductionStatementApprovalAllocation } from "@/interfaces/api/production-statement-approval-allocation.interface"

export class ProductionStatementApprovalAllocationRepository extends BaseRepository<IProductionStatementApprovalAllocation> {
  protected resourcePath = "administration/production-statement-approval-allocations"
}
